// @flow
import React from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';
import type { User as UserType } from '../../../types';
import User from './User';

type Props = $ReadOnly<{
    users: $ReadOnlyArray<string>,
    noUsersMessage?: Node,

    onEdit: (user: UserType) => void
}>;
function UserList({ users, noUsersMessage, onEdit }: Props) {
    if(users.length === 0) {
        return noUsersMessage || (
            <FormattedMessage
                id="users.noUsers"
                defaultMessage="No users"
            />
        );
    }

    return (
        <div>
            {users.map((userId, index) => (
                <User
                    key={index}
                    userId={userId}
                    onEdit={onEdit}
                />
            ))}
        </div>
    );
}

export default UserList;